export default "__VITE_ASSET__CTo7Q2PK__";